import { ReactNode, useEffect, useState } from 'react';
import { LocationNameDisplay, useLocations } from '@adsk/acc-locations-components';
import { CSSObject } from 'styled-components';

const BLOCK_STYLE: CSSObject = { ':not(:last-of-type)': { marginBottom: 8 } };
export const INLINE_STYLE: CSSObject = {
  display: 'inline',
  ':not(:last-of-type):after': { content: "', '" },
  whiteSpace: 'normal',
};

const DISPLAY_VARIANTS = {
  BLOCK: BLOCK_STYLE,
  INLINE: INLINE_STYLE,
};

export type useMultipleLocationsDisplayType = (args: {
  locationIds?: string[];
  textStyle?: CSSObject;
  returnOnlyExistingLocations?: boolean;
}) => {
  locationNamesNodes: ReactNode[];
  isLoading: boolean;
  isError: boolean;
};

const pureUseMultipleLocationsDisplay: useMultipleLocationsDisplayType = ({
  locationIds,
  textStyle,
  returnOnlyExistingLocations = true,
}) => {
  const { isError, treeDataMap, isLoading } = useLocations();
  const [locationNamesNodes, setLocationNamesNodes] = useState<ReactNode[]>([]);

  useEffect(() => {
    const isTreeReady = Object.keys(treeDataMap || {}).length;

    if (isTreeReady && locationIds) {
      const filteredLocationIds = returnOnlyExistingLocations
        ? locationIds.filter((id) => treeDataMap[id])
        : locationIds;

      const locationsNames = filteredLocationIds.map((id) => (
        <LocationNameDisplay key={id} locationNodeId={id} style={textStyle} />
      ));

      setLocationNamesNodes(locationsNames);
    }
  }, [treeDataMap, locationIds]);

  return {
    locationNamesNodes,
    isLoading,
    isError,
  };
};

export const useMultipleLocationsDisplay = Object.assign(pureUseMultipleLocationsDisplay, {
  DISPLAY_VARIANTS,
});
